// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TerceraChartCashItemSeriesCacheScreenDataDateChangeType;
(function (TerceraChartCashItemSeriesCacheScreenDataDateChangeType) {
    TerceraChartCashItemSeriesCacheScreenDataDateChangeType[TerceraChartCashItemSeriesCacheScreenDataDateChangeType["None"] = 0] = "None";
    TerceraChartCashItemSeriesCacheScreenDataDateChangeType[TerceraChartCashItemSeriesCacheScreenDataDateChangeType["Day"] = 1] = "Day";
    TerceraChartCashItemSeriesCacheScreenDataDateChangeType[TerceraChartCashItemSeriesCacheScreenDataDateChangeType["Week"] = 2] = "Week";
    TerceraChartCashItemSeriesCacheScreenDataDateChangeType[TerceraChartCashItemSeriesCacheScreenDataDateChangeType["Month"] = 3] = "Month";
    TerceraChartCashItemSeriesCacheScreenDataDateChangeType[TerceraChartCashItemSeriesCacheScreenDataDateChangeType["Year"] = 4] = "Year";
})(TerceraChartCashItemSeriesCacheScreenDataDateChangeType || (TerceraChartCashItemSeriesCacheScreenDataDateChangeType = {}));
export var TerceraChartCashItemSeriesDataType;
(function (TerceraChartCashItemSeriesDataType) {
    TerceraChartCashItemSeriesDataType[TerceraChartCashItemSeriesDataType["Absolute"] = 0] = "Absolute";
    TerceraChartCashItemSeriesDataType[TerceraChartCashItemSeriesDataType["Relative"] = 1] = "Relative";
    TerceraChartCashItemSeriesDataType[TerceraChartCashItemSeriesDataType["Log"] = 2] = "Log";
})(TerceraChartCashItemSeriesDataType || (TerceraChartCashItemSeriesDataType = {}));
export var TerceraChartCashItemSeriesDataTypeBasisType;
(function (TerceraChartCashItemSeriesDataTypeBasisType) {
    TerceraChartCashItemSeriesDataTypeBasisType[TerceraChartCashItemSeriesDataTypeBasisType["BeginOfScreen"] = 0] = "BeginOfScreen";
    TerceraChartCashItemSeriesDataTypeBasisType[TerceraChartCashItemSeriesDataTypeBasisType["BeginOfData"] = 1] = "BeginOfData";
    TerceraChartCashItemSeriesDataTypeBasisType[TerceraChartCashItemSeriesDataTypeBasisType["BeginOfDay"] = 2] = "BeginOfDay";
})(TerceraChartCashItemSeriesDataTypeBasisType || (TerceraChartCashItemSeriesDataTypeBasisType = {}));
export var TerceraChartCashItemSeriesGetIndexType;
(function (TerceraChartCashItemSeriesGetIndexType) {
    TerceraChartCashItemSeriesGetIndexType[TerceraChartCashItemSeriesGetIndexType["Exactly"] = 0] = "Exactly";
    TerceraChartCashItemSeriesGetIndexType[TerceraChartCashItemSeriesGetIndexType["ExactlyOrNearestNonEmpty"] = 1] = "ExactlyOrNearestNonEmpty";
})(TerceraChartCashItemSeriesGetIndexType || (TerceraChartCashItemSeriesGetIndexType = {}));
export function getTerceraChartCashItemSeriesDataTypeKey(value) {
    switch (value) {
        case TerceraChartCashItemSeriesDataType.Absolute:
            return 'property.GraphicType.Absolute';
        case TerceraChartCashItemSeriesDataType.Relative:
            return 'property.GraphicType.Relative';
        case TerceraChartCashItemSeriesDataType.Log:
            return 'property.GraphicType.Log';
        default:
            return '';
    }
}
export function getTerceraChartCashItemSeriesDataTypeBasisTypeKey(value) {
    switch (value) {
        case TerceraChartCashItemSeriesDataTypeBasisType.BeginOfScreen:
            return 'property.RelativeCalculationType.BeginOfTheScreen';
        case TerceraChartCashItemSeriesDataTypeBasisType.BeginOfData:
            return 'property.RelativeCalculationType.BeginOfTheData';
        case TerceraChartCashItemSeriesDataTypeBasisType.BeginOfDay:
            return 'property.RelativeCalculationType.BeginOfTheDay';
        default:
            return '';
    }
}
